


import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

@Component({})
export default class Checkbox extends Vue {
  @Prop({ default: false }) checked!: boolean;
  @Prop() label!: string;

  @Emit('input')
  private handleClick() {
    return !this.checked;
  }
}
